import axios from "axios";
import {
  getApiGraphUrl,
  getDefaultLanguage,
  getRegion,
  getUserToken,
} from "@src/utils/getAxiosConfig";
import { store } from "@root/store";
import { useSelector } from "react-redux";

export function executeQuery(payload) {
  const is_apk = localStorage.getItem("isAPKFlag");
  const { token, region, bundlingId, defaultLanguage, ...payloadVariables } = payload;
  const isMoneyBack = store.getState()?.overviewReducer?.overViewDetails?.course?.metaData?.addOnData?.addOnOptionId;
  const moneyBackEnable = store.getState()?.overviewReducer?.moneyBackGuarantee?.isRemoveButtonEnable;

  return axios
    .post(
      `${getApiGraphUrl()}`,
      {
        query: payload?.query,
        variables: {
          token: token || getUserToken(),
          bundlingId: bundlingId,
          ...payloadVariables?.variables,
          optedAddOn: (isMoneyBack && moneyBackEnable) ? isMoneyBack : 0,
        },
      },
      {
        headers: {
          region: region || getRegion(),
          "accept-language": defaultLanguage || getDefaultLanguage(),
          "app-version": "51",
          "is-apk": is_apk,
          "via-whatsapp" : payload?.purchaseViaWhatsappV2
        },
      }
    )
    .then((response) => {
      let { errors } = response.data;
      if (errors)
        return {
          message: errors[0].message,
          data: response.data,
          hasErrors: true,
        };
      return response;
    })
    .catch((err) => {
      return err;
    });
}
